interface Args {
  measuredPixels: number;
  referenceMeters: number;
  pixelsPerMeter: number;
}

export interface BackgroundScaleMultiplierResult {
  measuredPixels: number;
  targetPixels: number;
  multiplier: number;
  percentage: number;
  differencePixels: number;
}

export const calculateBackgroundScaleMultiplier = ({
  measuredPixels,
  referenceMeters,
  pixelsPerMeter,
}: Args): BackgroundScaleMultiplierResult | null => {
  if (measuredPixels <= 0 || referenceMeters <= 0 || pixelsPerMeter <= 0) return null;

  const targetPixels = referenceMeters * pixelsPerMeter;
  const multiplier = targetPixels / measuredPixels;

  return {
    measuredPixels,
    targetPixels,
    multiplier,
    percentage: multiplier * 100,
    differencePixels: targetPixels - measuredPixels,
  };
};
